<div class="widget" fxFlex="100" fxFlex.gt-sm="100">
    <div class="fuse-card auto-width mb-12 mat-card p-0 mr-12">
        <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
            <table class="coordinator-company-tbl">
                <caption></caption>
                <thead>
                    <tr>
                        <th>Compañías</th>
                        <th>Absentismo</th>
                        <th>Abs. Mensual</th>
                        <th>Bajas Activas</th>
                        <th>
                            <app-year-toggle (YearChange)="yearChanged($event)">
                            </app-year-toggle>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>

        <div *ngIf="isLoading" class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
        <div *ngIf="!isLoading">
            <div class="fuse-card auto-width mat-card ml-12 mr-12 mb-12 p-0"
                *ngIf="!companyList || (companyList && companyList.length === 0)">
                <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                    class="dis-block p-10">
                    <p>No hay empresas para el coordinador.</p>
                </div>
            </div>
            <div class="fuse-card auto-width mat-card ml-12 mr-12 mb-12 p-0" *ngFor="let company of companyList">
                <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                    class="dis-block p-t-0 p-10">
                    <div class="p-10">
                        <table class="coordinator-company-tbl">
                            <caption></caption>
                            <thead>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </thead>
                            <tbody>
                                <tr class="line-h-11">
                                    <td>{{company.nombre}}</td>
                                    <td>{{(company.absentismoDiario) ? (company.absentismoDiario | number : '1.1-1') +
                                        "%" : "N/A"}}</td>
                                    <td>{{(company.absentismoMensual) ? (company.absentismoMensual | number : '1.1-1') +
                                        "%" : "N/A"}}

                                        <span *ngIf="company.absentismoMensual && company.absAnterior">
                                            <mat-icon role="img" *ngIf="company.absentismoMensual > company.absAnterior"
                                                class="mat-icon notranslate green-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                                aria-hidden="true" data-mat-icon-type="font">call_received
                                            </mat-icon>

                                            <mat-icon role="img" *ngIf="company.absentismoMensual < company.absAnterior"
                                                class="mat-icon notranslate red-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                                aria-hidden="true" data-mat-icon-type="font">call_made
                                            </mat-icon>
                                            <mat-icon role="img"
                                                *ngIf="company.absentismoMensual === company.absAnterior"
                                                class="mat-icon notranslate blue-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                                aria-hidden="true" data-mat-icon-type="font">drag_handle
                                            </mat-icon>
                                        </span>

                                    </td>
                                    <td>{{(company.bajas) ? company.bajas : "N/A"}}</td>
                                    <td class="text-right p-r-10">
                                        <mat-icon (click)="openAddEditPopup(false, company)"
                                            class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate add-date">
                                            add</mat-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- company date slider -->
                    <div class="carousel-coordinator m-t-0">
                        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row"
                            fxLayoutAlign.gt-sm="start start">
                            <div class="btn-w-100"
                                *ngIf="(companyVisitList | listFilter: 'COMPANYID': company.empresaId).length > 0">
                                <p-carousel [value]="companyVisitList | listFilter: 'COMPANYID': company.empresaId" [showIndicators] ="true" 
                                [showNavigators] ="true" 
                                    [numVisible]="8" [numScroll]="1" [styleClass]="'visit-carousel'">
                                    <ng-template let-visit pTemplate="item">
                                        <button [ngClass]="{'add-date-active' : company.selectedVisitaId === visit.id}"
                                            class="mat-raised-button mat-button-base btn-date"
                                            (click)="toggleDetails(company, visit.id)">

                                            <mat-icon *ngIf="visit.tipo === 'Visita Coordinador'"
                                                class="mat-icon material-icons mat-icon-no-color notranslate visit-icon"
                                                role="img">
                                                visibility</mat-icon>

                                            <mat-icon *ngIf="visit.tipo === 'Contacto Telefónico'"
                                                class="mat-icon material-icons mat-icon-no-color notranslate visit-icon"
                                                role="img">
                                                call</mat-icon>

                                            {{visit.fecha | date : 'dd/MM'}}
                                            <span *ngIf="!visit.isDone"> **</span>
                                        </button>
                                    </ng-template>
                                </p-carousel>
                            </div>
                            <div class="btn-w-100"
                                *ngIf="(companyVisitList | listFilter: 'COMPANYID': company.empresaId).length === 0">
                                Actualmente no hay datos de visitas disponibles
                            </div>
                        </div>

                    </div>
                    <!--/ company date slider -->

                    <!-- company client-tbl -->
                    <div *ngIf="company.showVisit && company.selectedVisitDetails" >
                        <table class="mat-table coordinator-client-tbl">
                            <caption></caption>
                            <thead>
                                <th></th>
                                <th></th>
                                <th></th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <mat-icon *ngIf="company.selectedVisitDetails.asistentes || company.selectedVisitDetails.asistentesEmpresa || company.selectedVisitDetails.asistentesMutua"
                                            class="mat-icon material-icons mat-icon-no-color notranslate"
                                            [matTooltip]="matToolTip" role="img">
                                            <span class="material-symbols-outlined">
                                                contact_phone
                                                </span>
                                        </mat-icon>
                                    </td>
                                    <td class="font-bold "> {{company.selectedVisitDetails.asunto}} <br> <span style="font-weight: 100">{{company.selectedVisitDetails.comentarios}}</span></td>
                                    <td></td>
                                </tr>
                                <tr class="line-h-11">
                                    <td></td>
                                    <td>{{company.selectedVisitDetails.resumen}}</td>
                                    <td class="text-right p-r-10">
                                        <mat-icon (click)="openAddEditPopup(true, company)"
                                            class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate"
                                            role="img">
                                            edit</mat-icon>
                                        <mat-icon (click)="onDeleteVisita(company.selectedVisitDetails.id)"
                                            class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate"
                                            role="img">
                                            delete</mat-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--/ company client-tbl -->
                </div>
            </div>
        </div>
    </div>
</div>